var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagBrCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4959C0 19.4004 5.5996 24.9917 12.4959 24.9917C19.3921 24.9917 24.9917 19.3921 24.9917 12.4959C24.9917 5.5996 19.4004 0 12.4959 0C5.59135 0 0 5.5996 0 12.4959Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.4959C25 19.4004 19.4004 24.9917 12.5041 24.9917C5.60786 24.9917 0 19.4004 0 12.4959C0 5.59135 5.5996 0 12.4959 0C19.3921 0 24.9917 5.5996 24.9917 12.4959",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4876 4.73242L0.545105 12.4711L12.4876 20.2181L24.4384 12.4711L12.4876 4.73242Z",
    fill: "#FECA04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5702 7.44971C15.3865 7.44971 17.666 9.72919 17.666 12.5455C17.666 15.3618 15.3865 17.6413 12.5702 17.6413C9.75388 17.6413 7.4744 15.3618 7.4744 12.5455C7.4744 9.72919 9.75388 7.44971 12.5702 7.44971Z",
    fill: "#2E2C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0073 10.7202L14.0733 10.9019L14.2716 10.9102L14.1229 11.0341L14.1725 11.224L14.0073 11.1166L13.8421 11.224L13.8916 11.0341L13.7347 10.9102L13.9329 10.9019L14.0073 10.7202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7512 11.9756L13.8008 12.0995L13.9412 12.116L13.8338 12.1986L13.8669 12.339L13.7512 12.2647L13.6356 12.339L13.6686 12.1986L13.5613 12.116L13.7017 12.0995L13.7512 11.9756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41593 11.3477L8.49026 11.5294L8.68848 11.5459L8.53156 11.6698L8.58111 11.8515L8.41593 11.7523L8.25075 11.8515L8.3003 11.6698L8.15164 11.5459L8.34986 11.5294L8.41593 11.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6458 12.4878L10.7037 12.6365L10.8688 12.6447L10.745 12.7521L10.7863 12.909L10.6458 12.8264L10.5054 12.909L10.5467 12.7521L10.4146 12.6447L10.5798 12.6365L10.6458 12.4878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29963 13.2803L9.33267 13.3794L9.44004 13.3876L9.35745 13.4537L9.38222 13.5528L9.29963 13.495L9.20878 13.5528L9.23356 13.4537L9.15097 13.3876L9.25834 13.3794L9.29963 13.2803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86191 13.4702L8.93624 13.6519L9.1262 13.6602L8.97754 13.7923L9.02709 13.974L8.86191 13.8749L8.69673 13.974L8.74629 13.7923L8.59763 13.6602L8.78758 13.6519L8.86191 13.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28378 13.9492L8.3416 14.1061L8.50678 14.1144L8.38289 14.2218L8.42419 14.3787L8.28378 14.2878L8.14338 14.3787L8.18468 14.2218L8.06079 14.1144L8.22597 14.1061L8.28378 13.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84473 13.9907L9.9108 14.1476L10.076 14.1559L9.94384 14.2633L9.98513 14.4202L9.84473 14.3293L9.71258 14.4202L9.74562 14.2633L9.62173 14.1559L9.78692 14.1476L9.84473 13.9907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73737 14.5688L9.78692 14.701L9.92732 14.7093L9.81996 14.8001L9.85299 14.9405L9.73737 14.8579L9.62174 14.9405L9.65478 14.8001L9.54741 14.7093L9.68781 14.701L9.73737 14.5688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4807 15.0146L10.555 15.1963L10.7532 15.2046L10.5963 15.3285L10.6459 15.5184L10.4807 15.4193L10.3155 15.5184L10.365 15.3285L10.2164 15.2046L10.4146 15.1963L10.4807 15.0146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4711 16.394L12.4959 16.4601L12.5702 16.4684L12.5124 16.5097L12.5289 16.584L12.4711 16.5427L12.405 16.584L12.4215 16.5097L12.3637 16.4684L12.4381 16.4601L12.4711 16.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5454 13.0903L12.6032 13.2473L12.7684 13.2555L12.6445 13.3629L12.6858 13.5198L12.5454 13.429L12.405 13.5198L12.4463 13.3629L12.3224 13.2555L12.4794 13.2473L12.5454 13.0903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9997 13.52L13.0657 13.6769L13.2309 13.6852L13.0988 13.7926L13.1401 13.9495L12.9997 13.8586L12.8675 13.9495L12.9088 13.7926L12.7767 13.6852L12.9419 13.6769L12.9997 13.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2729 14.0073L12.3142 14.0982L12.4215 14.1064L12.339 14.1725L12.3637 14.2799L12.2729 14.2221L12.1903 14.2799L12.2151 14.1725L12.1325 14.1064L12.2398 14.0982L12.2729 14.0073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9425 13.6274L11.9921 13.7513L12.1325 13.7596L12.0251 13.8504L12.0581 13.9908L11.9425 13.9165L11.8269 13.9908L11.8599 13.8504L11.7526 13.7596L11.893 13.7513L11.9425 13.6274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5041 14.5605L12.5702 14.7422L12.7684 14.7588L12.6198 14.8826L12.6693 15.0726L12.5041 14.9652L12.3389 15.0726L12.3885 14.8826L12.2316 14.7588L12.4298 14.7422L12.5041 14.5605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5778 15.1968L13.6274 15.3207L13.7678 15.3372L13.6604 15.4198L13.6934 15.5602L13.5778 15.4858L13.4622 15.5602L13.4952 15.4198L13.3878 15.3372L13.5283 15.3207L13.5778 15.1968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9908 15.7827L14.0486 15.9314L14.2137 15.9396L14.0899 16.047L14.1312 16.2039L13.9908 16.1213L13.8504 16.2039L13.8916 16.047L13.7678 15.9396L13.9247 15.9314L13.9908 15.7827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.445 15.3203L14.5028 15.4525L14.6432 15.4607L14.5276 15.5516L14.5689 15.6837L14.445 15.6094L14.3294 15.6837L14.3624 15.5516L14.255 15.4607L14.3954 15.4525L14.445 15.3203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0479 16.2207L15.0975 16.3528L15.2379 16.3611L15.1305 16.4437L15.1635 16.5841L15.0479 16.5098L14.9323 16.5841L14.9653 16.4437L14.8579 16.3611L14.9983 16.3528L15.0479 16.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0562 15.6592L15.114 15.8078L15.2791 15.8244L15.147 15.9235L15.1883 16.0886L15.0562 15.9978L14.9158 16.0886L14.957 15.9235L14.8249 15.8244L14.9901 15.8078L15.0562 15.6592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0396 15.2046L15.0892 15.3367L15.2296 15.345L15.1222 15.4358L15.1553 15.568L15.0396 15.4937L14.924 15.568L14.9571 15.4358L14.8497 15.345L14.9901 15.3367L15.0396 15.2046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5352 15.2046L15.5847 15.3367L15.7251 15.345L15.6178 15.4358L15.6508 15.5762L15.5352 15.4937L15.4196 15.5762L15.4526 15.4358L15.3452 15.345L15.4856 15.3367L15.5352 15.2046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.006 14.9653L16.0638 15.114L16.2289 15.1223L16.1051 15.2296L16.1464 15.3865L16.006 15.304L15.8655 15.3865L15.9068 15.2296L15.783 15.1223L15.9481 15.114L16.006 14.9653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2455 14.5605L16.3033 14.7175L16.4685 14.7257L16.3446 14.8331L16.3776 14.99L16.2455 14.8992L16.1051 14.99L16.1463 14.8331L16.0142 14.7257L16.1794 14.7175L16.2455 14.5605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0472 14.0239L16.1133 14.2056L16.3115 14.2221L16.1629 14.346L16.2042 14.536L16.0472 14.4286L15.8821 14.536L15.9234 14.346L15.7747 14.2221L15.9729 14.2056L16.0472 14.0239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7823 14.1475L16.8318 14.2796L16.9722 14.2879L16.8649 14.3787L16.8979 14.5109L16.7823 14.4365L16.6584 14.5109L16.6914 14.3787L16.5841 14.2879L16.7245 14.2796L16.7823 14.1475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82954 10.6541C7.76346 10.8193 7.70565 10.9927 7.6561 11.1662C8.25075 11.0753 8.86191 11.0258 9.48134 11.0258C12.5041 11.0258 15.2874 12.1573 17.4348 14.0238C17.4843 13.8504 17.5256 13.6852 17.5669 13.5035C15.4113 11.6452 12.628 10.522 9.59696 10.522C8.99406 10.522 8.40767 10.5633 7.82954 10.6541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24248 10.8606C8.24248 10.7698 8.30029 10.6872 8.3994 10.6789C8.49851 10.6707 8.57284 10.7367 8.5811 10.8276C8.5811 10.9184 8.52328 11.001 8.42418 11.0093C8.32507 11.0175 8.25074 10.9515 8.24248 10.8606ZM8.50677 10.8358C8.50677 10.778 8.45721 10.7367 8.3994 10.745C8.34159 10.745 8.30855 10.7945 8.31681 10.8524C8.31681 10.9102 8.36636 10.9515 8.42418 10.9432C8.48199 10.9432 8.51503 10.8937 8.50677 10.8358Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82888 10.6543H8.97754C8.97754 10.6543 9.05187 10.6543 9.06839 10.6791C9.08491 10.6956 9.10142 10.7204 9.10142 10.7534C9.10142 10.803 9.07665 10.836 9.03535 10.8525L9.11794 10.9599H9.03535L8.96102 10.869H8.90321V10.9764H8.83714L8.82062 10.6626L8.82888 10.6543ZM8.97754 10.803C8.97754 10.803 9.02709 10.7864 9.02709 10.7534C9.02709 10.7534 9.00232 10.7121 8.96928 10.7121H8.90321V10.803H8.97754Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35745 10.6377H9.48134C9.58045 10.6377 9.64652 10.7038 9.64652 10.7946C9.64652 10.8855 9.58045 10.9515 9.48134 10.9515H9.35745V10.6377ZM9.48134 10.8937C9.53915 10.8937 9.58045 10.8524 9.58045 10.8029C9.58045 10.7451 9.53915 10.7038 9.48134 10.7038H9.42352V10.8937H9.48134Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91081 10.6377L10.1503 10.646L10.1421 10.712L9.97688 10.7038V10.7698L10.1255 10.7781L10.1173 10.8359L9.96862 10.8277V10.8937L10.1421 10.902L10.1338 10.9681L9.89429 10.9598L9.91081 10.6377Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4146 10.6626L10.4889 10.6709L10.555 10.8113L10.6541 10.6874L10.7284 10.6956L10.7037 11.0095L10.6293 11.0012L10.6458 10.7947L10.5467 10.9269L10.4724 10.7865L10.4559 10.9847H10.3816L10.4146 10.6626Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.48 10.7861L11.7195 10.8274L11.703 10.8935L11.5378 10.8605L11.5296 10.9265L11.6782 10.9513L11.6617 11.0091L11.5131 10.9843L11.5048 11.0504L11.6782 11.0835L11.6617 11.1413L11.4305 11.1L11.48 10.7861Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4794 10.9927L12.6032 11.0257C12.6776 11.0422 12.7106 11.1 12.6941 11.1661C12.6776 11.2404 12.6115 11.257 12.5454 11.2404L12.4959 11.2239L12.4711 11.3148L12.405 11.2983L12.4876 10.9927H12.4794ZM12.5619 11.1826C12.5619 11.1826 12.6198 11.1826 12.628 11.1496C12.628 11.1496 12.6198 11.1 12.5867 11.0918L12.5372 11.0753L12.5124 11.1661L12.5619 11.1826Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0905 11.166L13.2309 11.2073C13.2309 11.2073 13.297 11.2403 13.3052 11.2651C13.3135 11.2899 13.3218 11.3146 13.3052 11.3394C13.2887 11.389 13.2557 11.4137 13.2144 11.4137L13.2557 11.5459L13.1814 11.5211L13.1483 11.4055L13.0988 11.389L13.0657 11.4881L12.9997 11.4633L13.0988 11.1577L13.0905 11.166ZM13.1814 11.3559C13.1814 11.3559 13.2392 11.3559 13.2474 11.3312C13.2474 11.3312 13.2474 11.2816 13.2061 11.2733L13.1401 11.2486L13.1153 11.3394L13.1814 11.3642V11.3559Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6439 11.5129C13.6769 11.4303 13.7678 11.3808 13.8586 11.4221C13.9495 11.4551 13.9907 11.546 13.9577 11.6368C13.9247 11.7194 13.8338 11.7689 13.743 11.7277C13.6521 11.6946 13.6108 11.6038 13.6439 11.5129ZM13.8916 11.6038C13.9082 11.5542 13.8916 11.4964 13.8338 11.4799C13.7843 11.4634 13.7265 11.4799 13.7099 11.5377C13.6934 11.5872 13.7099 11.6451 13.7678 11.6616C13.8173 11.6781 13.8751 11.6616 13.8916 11.6038Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3046 11.7775C14.3376 11.6949 14.4367 11.6536 14.5193 11.6949C14.5689 11.7197 14.5937 11.7445 14.6184 11.7858L14.5606 11.8188C14.5606 11.8188 14.5276 11.7692 14.4946 11.7527C14.445 11.7362 14.3954 11.7527 14.3707 11.8023C14.3459 11.8601 14.3707 11.9096 14.4202 11.9344C14.445 11.9427 14.4698 11.9509 14.4863 11.9427L14.5028 11.9014L14.4367 11.8766L14.4615 11.8188L14.5854 11.8766L14.5276 12.0005C14.5276 12.0005 14.4367 12.017 14.3872 11.9922C14.2963 11.9509 14.2633 11.8601 14.3046 11.7775Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9984 11.9258L15.1305 11.9919C15.1305 11.9919 15.1883 12.0331 15.1966 12.0662C15.1966 12.091 15.1966 12.1157 15.1883 12.1405C15.1635 12.1901 15.1222 12.2066 15.0809 12.1983L15.0975 12.3305L15.0231 12.2974L15.0066 12.1736L14.9571 12.1488L14.9075 12.2396L14.8414 12.2066L14.9818 11.9258H14.9984ZM15.0562 12.124C15.0562 12.124 15.114 12.124 15.1222 12.1075C15.1222 12.1075 15.1222 12.0579 15.0975 12.0414L15.0396 12.0084L14.9984 12.091L15.0644 12.124H15.0562Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5847 12.2314L15.7912 12.3471L15.7582 12.4049L15.6095 12.314L15.5765 12.3718L15.7086 12.4462L15.6756 12.504L15.5434 12.4297L15.5104 12.4875L15.6673 12.5701L15.6343 12.6279L15.4196 12.504L15.5847 12.2314Z",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9564 12.7685L16.0142 12.752C16.0142 12.752 16.039 12.8181 16.072 12.8346C16.0968 12.8511 16.1133 12.8511 16.1298 12.8346C16.1298 12.8346 16.1298 12.8015 16.0968 12.7685C16.0555 12.7189 16.0307 12.6859 16.0638 12.6281C16.0968 12.5785 16.1546 12.5703 16.2124 12.6033C16.2537 12.6281 16.2785 12.6611 16.2868 12.7024L16.2289 12.7272C16.2289 12.7272 16.1959 12.6694 16.1794 12.6529C16.1546 12.6364 16.1381 12.6446 16.1298 12.6529C16.1298 12.6529 16.1298 12.6859 16.1629 12.7272C16.2042 12.7768 16.2289 12.8181 16.1959 12.8593C16.1629 12.9089 16.1051 12.9172 16.0472 12.8759C16.0059 12.8511 15.9729 12.8098 15.9646 12.7602",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4602 13.0988L16.5263 13.0823C16.5263 13.0823 16.551 13.1484 16.5841 13.1649C16.6089 13.1814 16.6254 13.1814 16.6419 13.1649C16.6419 13.1649 16.6419 13.1401 16.6171 13.0906C16.5758 13.041 16.551 12.9997 16.5841 12.9502C16.6171 12.9006 16.6749 12.9006 16.7327 12.9337C16.774 12.9584 16.7905 12.9915 16.8071 13.0328L16.7493 13.0576C16.7493 13.0576 16.7245 12.9997 16.6997 12.9832C16.6749 12.9667 16.6584 12.9667 16.6501 12.9832C16.6501 12.9832 16.6501 13.0163 16.6832 13.0576C16.7245 13.1071 16.741 13.1484 16.708 13.1897C16.6749 13.2393 16.6089 13.2393 16.5593 13.2062C16.518 13.1814 16.4932 13.1401 16.4767 13.0906",
    fill: "#049540"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0218 13.3796C17.0796 13.3053 17.1787 13.297 17.2531 13.3548C17.3274 13.4126 17.3356 13.52 17.2861 13.5861C17.2283 13.6604 17.1292 13.6687 17.0548 13.6109C16.9805 13.553 16.9723 13.4457 17.0218 13.3796ZM17.2283 13.5448C17.2613 13.5035 17.2613 13.4374 17.2118 13.4044C17.1705 13.3714 17.1127 13.3796 17.0796 13.4209C17.0466 13.4622 17.0466 13.5283 17.0961 13.5613C17.1374 13.5943 17.1952 13.5861 17.2283 13.5448Z",
    fill: "#049540"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrCircle);
export default __webpack_public_path__ + "static/media/flag-br-circle.b614b64f44d5840324ae312884d3500d.svg";
export { ForwardRef as ReactComponent };